import { Component } from '@angular/core';

@Component({
  selector: 'app-allapps',
  templateUrl: './allapps.component.html',
  styleUrl: './allapps.component.scss'
})
export class AllappsComponent {

}
